module.exports = __webpack_public_path__ + "img/logo.73a79d62.jpg";